module.exports = __webpack_public_path__ + "static/media/squared.ed3b7e5f.jpg";